<template>
  <v-layout row wrap class="px-0">
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="persons"
        item-key="personid" :sort-by="sortBy"
        :footer-props="footerProps" no-data-text="пусто" no-results-text="ничего не найдено"
        :items-per-page.sync="itemsPerPage"
        flat dense
      >
        <template v-slot:top>
          <v-toolbar flat>
            <slot>
            </slot>
          </v-toolbar>
        </template>
        <template v-slot:item.fullname="{ item }">
          <div :class="getPersonClass(item) + ' pa-1'">
            <router-link
            :to="{ name: 'person', params: { personid: item.personid } }"
            style="color: inherit; text-decoration: none"
            @click.native="memorize(item)"
            >
              <span style="font-size: 14px">
                {{ item.fullname }}
              </span>
              <v-icon small>call_made</v-icon>
            </router-link>
          </div>
        </template>
        <template v-slot:item.balance="{ item }">
          <span v-if="item.balance">{{ item.balance }}</span>
          <v-progress-circular v-else :size="16" indeterminate color="secondary"></v-progress-circular>
        </template>
        <template v-slot:item.arestudents="{ item }">
          {{ item.arestudents ? 'ученик' : '' }}
        </template>
        <template v-slot:item.archived="{ item }">
          {{ item.archived ? 'архив' : ''}}
        </template>
        <template v-slot:item.groups="{ item }">
          {{ item.groups && item.groups.length > 0 ? item.groups : ''}}
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ListPersons',
  props: [ 'persons', 'sort-by' ],
  data: () => ({
    showBalancesLimit: 20,
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 20, 100, { text:'Все', value:-1 } ]
    },
    itemsPerPage: 20
  }),
  computed: {
    showBalances () {
      return this.persons && this.persons.length <= this.showBalancesLimit
    },
    headers () {
      return [
        { text: 'id', value: 'personid', sortable: false },
        ...(this.showBalances ? [{ text: 'баланс', value: 'balance', sortable: false }] : []),
        { text: 'фио', value: 'fullname', },
        { text: 'карта', value: 'cardid', },
        { text: 'школа', value: 'schoolname', },
        { text: 'класс', value: 'positionname', },
        { text: 'телефон', value: 'phone', },
        { text: 'имейл', value: 'email', },
        { text: 'ученик?', value: 'arestudents', },
        { text: 'архивный?', value: 'archived', },
        { text: 'группы', value: 'groups', sortable: false },
      ]
    },
  },
  methods: {
    getPersonClass (x) {
       if (x.archived) return 'person-archived'
       if (!x.positionid) return 'person-noschool'
       if (x.registered) return 'person-normal'
       return ''
    },
    goPerson (x) {
      this.$emit('person', x)
      this.$store.dispatch('memorize', x)
      this.$router.push({ name: 'person', params: { personid: x.personid } })
    },
    memorize (person) {
      this.$store.dispatch('memorize', person)
    },
    async fetchBalance (person) {
      if (!this.persons || this.persons.length > this.showBalancesLimit) return '?'
      try {
        const { account } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-account',
          pl: person
        })
        if (!account) return
        const { balance } = account
        return balance
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
  },
  watch: {
    async persons (val) {
      if (!this.persons.__balanceFetched) {
        this.persons.__balanceFetched = true
        if (val && val.length < 30) {
          for (let x of val) {
            if (!x.balance) {
              x.balance = this.rubles(await this.fetchBalance({ personid: x.personid }))
            }
          }
          this.persons.__ob__.dep.notify()
        }
      }
    }
  }
}
</script>

<style lang="css">
</style>
